export default __webpack_public_path__ + "static/media/trans-cake.4558a7ca.png";